export const ROLE_TYPES = {
  ADMIN: "ADMIN",
  RESTAURANT: "RESTAURANT",
  CUSTOMER: "CUSTOMER",
  // DRAFT: "DRAFT",
  RESTAURANT_DRAFT: "RESTAURANT_DRAFT",
};
